<!-- 编辑工作经历 -->
<template>
  <div class="editing">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="title==0?'添加工作经历':title==1?'编辑教育经历':title==2?'编辑个人优势':title==3?'编辑求职意向':title==5?'编辑工作经历':title==6?'添加教育经历':'添加求职意向'"
      fixed
      placeholder
      z-index="10"
      @click-left="goBack"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 工作经历 -->
    <Work v-if="title==0||title==5" @sendWork="getWork" />
    <!-- 教育经历 -->
    <Degree v-if="title==1||title==6" @sendEduction="getEduction" />
    <!-- 编辑个人优势 -->
    <Advantage v-if="title==2" @sendMsg="save" />
    <!-- 求职意向 -->
    <Intention v-if="title==4||title==3" :resumeId="id" @func="positionMsg" />
    <!-- 按钮 -->
    <div class="btn" v-if="title!=undefined||title!=0||title!=6">
      <button class="clear" @click="deleteItem">删除</button>
      <button
        class="confirm"
        @click="saves"
        :disabled="disabled"
        :style="disabled?'background:rgba(255, 67, 67,0.5)':'background:rgba(255, 67, 67,1)'"
      >保存</button>
    </div>
    <!-- 按钮 -->
    <div class="request-btn" v-if="title==4||title==0||title==6">
      <button
        class="btns"
        @click="keepMsg"
        :disabled="disabled"
        :style="disabled?'background:rgba(255, 67, 67,0.5)':'background:rgba(255, 67, 67,1)'"
      >保存</button>
    </div>
  </div>
</template>

<script>
import Work from "./work";
import Degree from "./degree";
import Advantage from "./advantage";
import Intention from "./Intention";
import debounce from "@/until/debounce";
import {
  editInfo,
  editPosition,
  addWork,
  editWork,
  addEduction,
  editEduction,
  detelePosition,
  deleteEduction,
  deleteWork,
  addPosition
} from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {
    Work,
    Degree,
    Advantage,
    Intention
  },
  data() {
    return {
      title: "", //0 工作经历 1教育经历 2个人优势 3编辑求职意向 4添加求职意向
      disabled: true,
      id: "", //编辑id
      editId: [], //求职意向修改id
      workList: [], //工作经历
      eductionList: [] //教育经历
    };
  },
  computed: {},
  methods: {
    //返回上一页
    goBack() {
      this.$router.back();
    },
    save(val, value) {
      this.disabled = value;
      this.message = val;
    },
    positionMsg(val, id) {
      this.disabled = val;
      this.editId = id;
    },
    getWork(val, value) {
      this.disabled = value;
      this.workList = val;
    },
    getEduction(val, value) {
      this.disabled = value;
      this.eductionList = val;
    },

    // 修改个人优势
    manadvantage() {
      var that = this;
      var message = that.message.replace(/[, ]/g, "");
      var obj = {
        description: message
      };
      if (message.length == 0) {
        Toast("请输入内容后再提交！");
        return false;
      }
      editInfo(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
        }
      });
    },
    // 保存编辑后求职意向
    savePosition() {
      var that = this;
      var id = that.id;
      var list = that.editId;
      var obj = {
        resume_intent_id: id,
        district: list[2],
        wage: list[1],
        job: list[0]
      };
      editPosition(obj).then(res => {
        // //(res);
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 添加求职意向
    addPositionExproess() {
      var that = this;
      var editId = that.editId;
      var obj = {
        district: editId[2],
        wage: editId[1],
        job: editId[0]
      };
      addPosition(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 添加工作经历
    addworkExpress() {
      var that = this;
      let [company, jobs, start_time, end_time, description] = that.workList;
      var obj = {
        company: company,
        jobs: jobs,
        description: description,
        start_time: start_time,
        end_time: end_time == "至今" ? "" : end_time,
        todate: end_time == "至今" ? 1 : 0
      };
      addWork(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 编辑工作经历
    editWorkExpress() {
      var that = this;
      let [company, jobs, start_time, end_time, description] = that.workList;
      var obj = {
        company: company,
        jobs: jobs,
        resume_work_id: that.id,
        description: description,
        start_time: start_time,
        end_time: end_time == "至今" ? "" : end_time,
        todate: end_time == "至今" ? 1 : 0
      };
      editWork(obj).then(res => {
        // //(res);
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 添加教育经历
    addEductionExpress() {
      var that = this;
      var eductionList = that.eductionList;
      var obj = {
        school: eductionList[0],
        education: eductionList[1],
        speciality: eductionList[2],
        start_time: `${eductionList[3][0]}-09`,
        end_time: `${eductionList[3][1]}-07`
      };
      addEduction(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 修改教育经历
    editEductionExpress() {
      var that = this;
      var eductionList = that.eductionList;
      var obj = {
        resume_education_id: that.id,
        school: eductionList[0],
        education: eductionList[1],
        speciality: eductionList[2],
        start_time: `${eductionList[3][0]}-09`,
        end_time: `${eductionList[3][1]}-07`
      };
      editEduction(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 添加保存
    keepMsg() {
      var that = this;
      var title = that.title;
    
      switch (title) {
        case 0:
          that.addworkExpress();
          break;
        case 6:
          that.addEductionExpress();
          break;
        case 4: //添加求职意向
          that.addPositionExproess();
          break;
      }
    },
    // 修改保存
    saves() {
      var that = this;
      var title = that.title;
      switch (title) {
        case 3:
          // 保存修改求职意向
          that.savePosition();
          break;
        case 2:
          //个人优势修改
          that.manadvantage();
          break;
        case 5: //工作经历修改
          that.editWorkExpress();
          break;
        case 1: //教育经历修改
          that.editEductionExpress();
      }
    },
    // 删除求职意向
    delPosition() {
      var that = this;
      var id = that.id;
      detelePosition({
        resume_intent_id: id
      }).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "删除成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 删除教育经历
    delEduction() {
      var that = this;
      var id = that.id;
      deleteEduction({
        resume_education_id: id
      }).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "删除成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 删除工作经历
    delWork() {
      var that = this;
      var id = that.id;
      deleteEduction({
        resume_work_id: id
      }).then(res => {
        //(res);

        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "删除成功！",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    //删除
    deleteItem() {
      var that = this;
      var title = that.title;
      switch (title) {
        case 3:
          // 删除求职意向
          that.delPosition();
          break;
        case 5: //删除工作经历
          that.delWork();
          break;
        case 1: //删除教育经历
          that.delEduction();
      }
    }
  },
  created() {
    this.title = this.$route.params.title;
    this.id = this.$route.params.id;
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
</style>